import { defineComponent as _defineComponent } from 'vue'
import TypedOutput from '@/ui/ai-explanation/ai-explanation-output/typed-output.vue'

interface Props {
  explanation: string
  showActions: boolean
  setShowActions: (show: boolean) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-explanation-output',
  props: {
    explanation: null,
    showActions: { type: Boolean },
    setShowActions: null
  },
  setup(__props: any) {

const props = __props as {
  explanation: string
  showActions: boolean
  setShowActions: (show: boolean) => void
}




function inTestMode (): boolean {
    // @ts-ignore
    return typeof window.useCasesTestMode !== 'undefined'
}


return { __sfc: true,props, inTestMode, TypedOutput }
}

})